import { SEO } from './seo';

export const CONSTANTS = {
  SEO
};
